import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);

  const navLinks = [
    { label: "Argumente", href: "#argumente" },
    { label: "Veranstaltungen", href: "#veranstaltungen" },
    { label: "Kontakt", href: "#kontakt" },
  ];

  const scrollTo = (href) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="header"
      className="fixed top-0 left-0 right-0 z-50 bg-[#0C1620]/80 backdrop-blur-xl border-b border-[#3A4F60]/30"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-14 sm:h-16">
        <Link to="/" className="flex items-center gap-2 sm:gap-3 flex-shrink-0" data-testid="logo-link">
          <img
            src="/images/vmbs-logo.png"
            alt="VMBS UG Logo"
            className="h-8 w-8 sm:h-10 sm:w-10 object-contain"
            data-testid="vmbs-logo"
          />
          <span className="font-heading text-lg sm:text-xl tracking-widest text-white font-semibold hidden sm:inline">
            V<span className="text-[#C5993A]">·</span>M<span className="text-[#C5993A]">·</span>B<span className="text-[#C5993A]">·</span>S
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-6 xl:gap-8">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => scrollTo(link.href)}
              className="text-xs xl:text-sm uppercase tracking-[0.12em] text-[#8899AA] hover:text-[#C5993A] transition-colors duration-300"
              data-testid={`nav-${link.label.toLowerCase()}`}
            >
              {link.label}
            </button>
          ))}
        </nav>

        <div className="hidden lg:block">
          <Button
            data-testid="header-cta-button"
            onClick={() => scrollTo("#kontakt")}
            className="bg-gradient-to-r from-[#C5993A] to-[#8B6B20] text-white font-medium px-4 xl:px-5 py-2 text-sm rounded hover:from-[#8B6B20] hover:to-[#C5993A] transition-all border-0"
          >
            Beratung vereinbaren
          </Button>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="lg:hidden text-[#F0F4F8] p-1"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          {mobileOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {mobileOpen && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-[#12202f] border-t border-[#3A4F60]/30 px-4 sm:px-6 py-4 space-y-3"
        >
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => scrollTo(link.href)}
              className="block w-full text-left text-sm uppercase tracking-[0.12em] text-[#8899AA] hover:text-[#C5993A] transition-colors py-2"
            >
              {link.label}
            </button>
          ))}
          <Button
            onClick={() => scrollTo("#kontakt")}
            className="w-full bg-gradient-to-r from-[#C5993A] to-[#8B6B20] text-white border-0 text-sm"
          >
            Beratung vereinbaren
          </Button>
        </div>
      )}
    </header>
  );
}
